import {
  InvoiceStatus,
  HealthcareClaimStatus,
} from '@principle-theorem/principle-core/interfaces';
import {
  ISerialisedDocumentReference,
  ISerialisedTimestamp,
} from '@principle-theorem/shared';
import {
  IBigQueryFirestoreModel,
  IBigQueryNamedDocument,
  IBigQueryReffable,
  IInvoiceDimensionItems,
  ITimestampedDimension,
} from './common';

export interface IInvoiceDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    IBigQueryBaseInvoice,
    ITimestampedDimension {
  paidAt?: ISerialisedTimestamp;
  cancelledAt?: ISerialisedTimestamp;
  cancellation?: {
    reason: string;
    replacement?: ISerialisedDocumentReference;
  };
  subTotal: number;
  tax: number;
  total: number;
}

interface IBigQueryAccountDetails {
  name: string;
  address: string;
  taxId?: string;
  bsb?: string;
  accNo?: string;
}

interface IBigQueryInvoiceStatusLog {
  status: InvoiceStatus;
  updatedAt: ISerialisedTimestamp;
}

interface IBigQueryAccountingInvoice {
  reference: string;
  from: IBigQueryAccountDetails;
  to: IBigQueryAccountDetails;
  statusHistory: IBigQueryInvoiceStatusLog[];
  status: InvoiceStatus;
  due?: ISerialisedTimestamp;
  issuedAt?: ISerialisedTimestamp;
  paidAt?: ISerialisedTimestamp;
}

interface IBigQueryBaseInvoice extends IBigQueryAccountingInvoice {
  items: Partial<IInvoiceDimensionItems>;
  practice: IBigQueryNamedDocument;
  claims?: IHealthcareClaim[];
}

interface IBigQueryHealthcareClaimProviderGroup {
  items: IBigQueryHealthcareClaimItem[];
  practitioner: IBigQueryNamedDocument;
  providerData?: {
    providerNumber: string;
    /**
     * ServiceTypeModality is not a valid avro enum
     */
    providerModality: string;
  };
}

interface IBigQueryHealthcareClaimItem {
  treatmentUid: string;
  serviceCodeUid: string;
  quantity: number;
  provider: IBigQueryNamedDocument;
}

interface IHealthcareClaim extends IBigQueryHealthcareClaimProviderGroup {
  uid: string;
  status: HealthcareClaimStatus;
  transactions: ISerialisedDocumentReference[];
}
